<template>
  <div class="min-h-screen bg-gray-50 flex">
    <!-- Sidebar -->
    <aside class="hidden md:flex md:flex-col w-64 flex-shrink-0 bg-gray-900 text-white">
      <div class="px-6 py-6 border-b border-gray-800">
        <p class="text-xs uppercase tracking-[0.3em] text-amber-500 font-semibold">Al Etimad</p>
        <h2 class="text-lg font-bold">Admin Panel</h2>
      </div>
      <nav class="flex-1 px-3 py-4 space-y-1">
        <router-link
          v-for="item in navItems"
          :key="item.path"
          :to="item.path"
          class="block rounded-xl px-4 py-2.5 text-sm font-medium text-gray-300 transition hover:bg-gray-800 hover:text-white"
          active-class="!bg-amber-500 !text-white"
        >
          {{ item.label }}
        </router-link>
      </nav>
      <div class="px-3 py-4 border-t border-gray-800">
        <router-link
          to="/admin/change-password"
          class="block rounded-xl px-4 py-2.5 text-sm font-medium text-gray-400 transition hover:bg-gray-800 hover:text-white"
          active-class="!bg-amber-500 !text-white"
        >
          Change Password
        </router-link>
        <router-link
          to="/"
          class="mt-1 block rounded-xl px-4 py-2.5 text-sm font-medium text-gray-400 transition hover:bg-gray-800 hover:text-white"
        >
          &larr; View Website
        </router-link>
        <button
          @click="handleLogout"
          class="mt-1 w-full text-left rounded-xl px-4 py-2.5 text-sm font-medium text-gray-400 transition hover:bg-gray-800 hover:text-white"
        >
          Log Out
        </button>
      </div>
    </aside>

    <!-- Mobile top bar -->
    <div class="md:hidden fixed top-0 inset-x-0 z-40 bg-gray-900 text-white flex items-center justify-between px-4 py-3">
      <h2 class="font-bold">Admin Panel</h2>
      <button @click="mobileNavOpen = !mobileNavOpen" class="p-2">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
    </div>
    <div v-if="mobileNavOpen" class="md:hidden fixed top-14 inset-x-0 z-40 bg-gray-900 text-white px-4 py-3 space-y-1">
      <router-link
        v-for="item in navItems"
        :key="item.path"
        :to="item.path"
        @click="mobileNavOpen = false"
        class="block rounded-xl px-4 py-2.5 text-sm font-medium text-gray-300 hover:bg-gray-800 hover:text-white"
        active-class="!bg-amber-500 !text-white"
      >
        {{ item.label }}
      </router-link>
      <router-link
        to="/admin/change-password"
        @click="mobileNavOpen = false"
        class="block rounded-xl px-4 py-2.5 text-sm font-medium text-gray-300 hover:bg-gray-800 hover:text-white"
        active-class="!bg-amber-500 !text-white"
      >
        Change Password
      </router-link>
      <router-link to="/" class="block rounded-xl px-4 py-2.5 text-sm font-medium text-gray-400 hover:bg-gray-800 hover:text-white">
        &larr; View Website
      </router-link>
      <button @click="handleLogout" class="w-full text-left rounded-xl px-4 py-2.5 text-sm font-medium text-gray-400 hover:bg-gray-800 hover:text-white">
        Log Out
      </button>
    </div>

    <!-- Main content -->
    <main class="flex-1 min-w-0 pt-14 md:pt-0">
      <router-view />
    </main>
  </div>
</template>

<script>
import { logout } from '../../services/authStore'

export default {
  name: 'AdminLayout',
  data() {
    return {
      mobileNavOpen: false,
      navItems: [
        { path: '/admin', label: 'Dashboard' },
        { path: '/admin/packages', label: 'Umrah Packages' },
        { path: '/admin/hotels', label: 'Hotels' },
        { path: '/admin/services', label: 'Services' },
        { path: '/admin/ziarat', label: 'Ziarat Tours' },
        { path: '/admin/gallery', label: 'Gallery' },
        { path: '/admin/reviews', label: 'Reviews' },
        { path: '/admin/vouchers', label: 'Vouchers' },
        { path: '/admin/invoices', label: 'Invoices' },
        { path: '/admin/ledger', label: 'Ledger' }
      ]
    }
  },
  methods: {
    async handleLogout() {
      await logout()
      this.$router.push('/admin/login')
    }
  }
}
</script>
